import { render, staticRenderFns } from "./BaseMenuListItem.vue?vue&type=template&id=bb002f82"
import script from "./BaseMenuListItem.vue?vue&type=script&lang=js"
export * from "./BaseMenuListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports